import { lazy } from 'react'

export const USD_ICON = lazy(() => import('constants/icons/usdIcon'))
export const EUR_ICON = lazy(() => import('constants/icons/eurIcon'))
export const RUB_ICON = lazy(() => import('constants/icons/rubIcon'))
export const INR_ICON = lazy(() => import('constants/icons/inrIcon'))
export const GBP_ICON = lazy(() => import('constants/icons/gbpIcon'))
export const JPY_ICON = lazy(() => import('constants/icons/jpyIcon'))
export const VND_ICON = lazy(() => import('constants/icons/vndIcon'))
export const SGD_ICON = lazy(() => import('constants/icons/sgdIcon'))
export const BRL_ICON = lazy(() => import('constants/icons/brlIcon'))
export const HKD_ICON = lazy(() => import('constants/icons/hkdIcon'))
export const CAD_ICON = lazy(() => import('constants/icons/cadIcon'))
export const IDR_ICON = lazy(() => import('constants/icons/idrIcon'))
export const TRY_ICON = lazy(() => import('constants/icons/tryIcon'))
export const NGN_ICON = lazy(() => import('constants/icons/ngnIcon'))
export const AUD_ICON = lazy(() => import('constants/icons/audIcon'))
export const PKR_ICON = lazy(() => import('constants/icons/pkrIcon'))
export const UAH_ICON = lazy(() => import('constants/icons/uahIcon'))
export const CNY_ICON = lazy(() => import('constants/icons/cnyIcon'))
export const KRW_ICON = lazy(() => import('constants/icons/krwIcon'))
export const COP_ICON = lazy(() => import('constants/icons/copIcon'))
export const ARS_ICON = lazy(() => import('constants/icons/arsIcon'))
export const MXN_ICON = lazy(() => import('constants/icons/mxnIcon'))
